// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__MQo7y","notes":"Notes_notes__2VI3i"};